module.exports = __webpack_public_path__ + "img/Billedbog_Laereboeker.314884ce.jpg";